import { InjectionToken } from '@angular/core';
import { ReportingViewsService } from './reporting-views.service';

/**
 * Injection token for the reporting-views service consumed by SavedViewsComponent.
 *
 * Default (provided in SharedModule) → ReportingViewsService (list-page views).
 * Override in DashboardModule        → DashboardReportingViewsService (dashboard views).
 *
 * This allows SavedViewsComponent to be reused unchanged across both contexts
 * while storing views in completely independent backend tables.
 */
export const REPORTING_VIEWS_SERVICE_TOKEN = new InjectionToken<ReportingViewsService>(
  'REPORTING_VIEWS_SERVICE_TOKEN',
);
